export const CODE_ENGINE_MARKERS = {
    codeEngineUsageStart: '// CODE_ENGINE_USAGE_START',
    codeEngineUsageEnd: '// CODE_ENGINE_USAGE_END',
};
